import React, { useEffect, useState } from "react";
import { ArrowLeftRight } from "lucide-react";

import { Input } from "../../../components/ui/input";

import { numeroParaTexto, pctDoMinimo, piso, reais, textoParaNumero } from "./formato";
import ReguaPreco from "./produtos/ReguaPreco";

const SEM_SETAS = "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";
const ROTULO = "block text-[10px] font-semibold uppercase tracking-wide text-muted-foreground mb-1";

// Dois jeitos de dizer a mesma coisa: "até X%" ou "mínimo R$ Y". Digitar um
// calcula o outro. Vazio = usa o desconto padrão da campanha.
export default function CampoMinimo({ preco, custo, pct, padraoPct, onPct }) {
  const usandoPadrao = pct === "" || pct == null;
  const pctEfetivo = usandoPadrao ? padraoPct : Number(pct);
  const minimo = piso(preco, pctEfetivo);
  const [textoRs, setTextoRs] = useState(numeroParaTexto(minimo));
  const [editandoRs, setEditandoRs] = useState(false);
  const [aviso, setAviso] = useState("");

  useEffect(() => { if (!editandoRs) setTextoRs(numeroParaTexto(minimo)); }, [minimo, editandoRs]);

  const aoDigitarRs = (texto) => {
    setTextoRs(texto);
    const valor = textoParaNumero(texto);
    if (valor == null) return;
    const novo = pctDoMinimo(preco, valor);
    if (novo == null || valor >= Number(preco)) { setAviso("O mínimo precisa ser menor que o preço."); return; }
    if (novo > 90) { setAviso("Desconto máximo é 90%."); return; }
    if (novo < 1) { setAviso("Desconto mínimo é 1%."); return; }
    setAviso("");
    onPct(novo);
  };
  const sobra = custo != null && Number(custo) > 0 ? minimo - custo : null;

  const padraoTxt = String(padraoPct).replace(".", ",");

  return (
    <div className="basis-full md:basis-auto md:flex-1 min-w-0 rounded-xl border bg-muted/30 p-2.5 flex flex-col lg:flex-row lg:items-center gap-x-5 gap-y-2.5"
      data-e2e="campo-desconto">
      <div className="flex items-end gap-2 shrink-0">
        <label>
          <span className={ROTULO}>Desconto até</span>
          <span className="relative block">
            <Input type="number" min={1} max={90} step="0.01" value={pct ?? ""} placeholder={String(padraoPct)}
              onChange={(e) => onPct(e.target.value === "" ? "" : Number(e.target.value))}
              className={`w-[6.5rem] h-9 pr-7 text-right font-bold tabular-nums ${SEM_SETAS}`} aria-label="Desconto máximo em %" />
            <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">%</span>
          </span>
        </label>
        <ArrowLeftRight className="w-4 h-4 text-muted-foreground mb-2.5 shrink-0" aria-hidden="true" />
        <label>
          <span className={ROTULO}>Mínimo em reais</span>
          <span className="relative block">
            <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">R$</span>
            <Input value={textoRs} inputMode="decimal"
              onFocus={() => setEditandoRs(true)} onBlur={() => { setEditandoRs(false); setAviso(""); }}
              onChange={(e) => aoDigitarRs(e.target.value)}
              className="w-[8rem] h-9 pl-8 text-right font-bold tabular-nums" aria-label="Valor mínimo em reais" data-e2e="campo-minimo-rs" />
          </span>
        </label>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-baseline justify-between gap-x-3 mb-1.5 text-[11px] text-muted-foreground leading-snug">
          <p data-e2e="texto-minimo">
            {aviso ? <b className="text-red-500">{aviso}</b> : (
              <>
                Valor mínimo pro estabelecimento: <b className="text-foreground tabular-nums">{reais(minimo)}</b>
                {sobra != null && sobra >= 0 && <> · {reais(sobra)} acima do custo</>}
              </>
            )}
          </p>
          {usandoPadrao ? <span>usa o padrão ({padraoTxt}%)</span>
            : <button type="button" className="text-primary font-semibold hover:underline" onClick={() => onPct("")}>usar o padrão ({padraoTxt}%)</button>}
        </div>
        <ReguaPreco preco={preco} minimo={minimo} custo={custo} />
      </div>
    </div>
  );
}
